/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from "react-router-dom"
import * as wording from '../js/wording.js';
import Button from '../UiComponent/Button.js';
import HTMLText from '../UiComponent/HTMLText.js';
import './Payment.scss'
import RaceInfoTable from './RaceInfoTable.js'
import RaceFormTable from './RaceFormTable.js'
import * as util from '../js/util.js'
import * as api from '../js/api.js'
import Image from '../UiComponent/Image.js'
import FormConfirmationBox from './FormConfirmationBox.js';
import { PayPalButton } from "react-paypal-button-v2";
import axios from 'axios';
class Payment extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fMsg: '',
			showError: false,
			errorMsg: '',
			paymentInfo: {},
			showConfirmPrompt: false,
			ready: false,
			apiReady: false,
			paid: false,
			end:false
		};

		if (window.urlParams && window.urlParams.orderId) {
			window.info.orderId = window.urlParams.orderId;
			util.saveSession('F');
		}
		this.isProcessing = false;
		this.getPaymentInfo = this.getPaymentInfo.bind(this);
		this.createOrder = this.createOrder.bind(this);
		this.onApprove = this.onApprove.bind(this)
		wording.getWording('/wording/Payment.json').then((wordingJson) => this.setState({ fMsg: wordingJson, ready: true }));
	}

	componentDidMount() {
		if (!window || !window.info || !window.info.orderId) {
			this.props.history.push(window.info.config.pathname + "/404.html");
			return;
		}

		this.props.rootHideShowLoading('show');
		this.getPaymentInfo(window.info.orderId, this.props.history, function (data, _this, history) {
			if (!data || data.success == 'N') {
				_this.props.rootHideShowLoading('hide');
				history.push(window.info.config.pathname + "/404.html");
				return;
			}
			if (data.code !== null && data.code !== undefined && data.code !== '') {
				if (data.code === "ALREADY_PAID") {
					_this.setState({ apiReady: true, paid: true });
				}else if (data.code === 'ALREADY_END') {
					_this.setState({ apiReady: true, end: true })
				} 
			} else {
				_this.setState({ apiReady: true, paymentInfo: data });
			}

			_this.props.rootHideShowLoading('hide');
		})
	}

	componentWillUnmount() {
	}


	getPaymentInfo(id, history, callback) {

		if (!id) {
			callback({ 'success': 'N', _this, history });
			return;
		}
		var data = new FormData();
		data.append('orderId', id);
		var apiInfo = {
			api: window.info.config.filepathname + '/php/api/getPaymentInfo.php',
			params: data
		};

		api.post(this, apiInfo, function (data, _this) {
			var returnJson = data || null;

			callback(returnJson, _this, history);
			return;
		});
	}
	createOrder() {
		return new Promise((resolve, reject) => {
		axios.post(window.info.config.filepathname + '/php/api/createPaymentOrder.php', { "orderId": window.info.orderId } || {})
			.then(resJson => {
				if (resJson.data.code && resJson.data.code === 'ALREADY_PAID') {
					this.setState({ paid: true })
				} else if (resJson.data.code && resJson.data.code === 'ALREADY_END') {
					this.setState({ end: true })
				} else if (resJson.data.orderId) {
					resolve(resJson.data.orderId);
				}else{
					reject(new Error('Failed to get order ID'));
				}
			})
			.catch(function (error) {
				reject(error);
			});
		})
	}
	onApprove() {
		axios.post(window.info.config.filepathname + '/php/api/confirmPaymentOrder.php', { "orderId": window.info.orderId } || {})
			.then(res => {
				if (res && res.data && res.data.success && res.data.success === 'Y') {
					this.setState({ paid: true })
				}
			})
			.catch(function (error) {
			})
				
	}
	render() {
		return (
			<div id="FormPage">
				{this.state.ready && this.state.apiReady && (
					<div className='form-title'>
						<div className='form-title-image-overlay'></div>
						<HTMLText className='title-desc' text={this.state.fMsg.formTitleZh + "<br/>" + this.state.fMsg.formTitleEn} />
					</div>
				)}
				{this.state.paid && this.state.ready && this.state.apiReady && (
					<div className='paidContent' dangerouslySetInnerHTML={{__html:this.state.fMsg.successPaymentZh +"<br/>"+this.state.fMsg.successPaymentEn}}>

					</div>
				)}
				{this.state.end && this.state.ready && this.state.apiReady && (
					<div className='endContent' dangerouslySetInnerHTML={{__html:this.state.fMsg.paymentEndZh +"<br/>"+this.state.fMsg.paymentEndEn}}>

					</div>
				)}
				{!this.state.paid && !this.state.end && this.state.ready && this.state.apiReady && (
					<div className='content'>
						<table className='info-table'>
							<tbody>
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.raceTitleZh + ":<br/>" + this.state.fMsg.raceTitleEn + ":"} />
									</td>
									<td>
										<HTMLText text={this.state.paymentInfo.raceTitleZh + "<br/>" + this.state.paymentInfo.raceTitleEn} />
									</td>
								</tr>
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.raceDateZh + ":<br/>" + this.state.fMsg.raceDateEn + ":"} />
									</td>
									<td>
										<HTMLText text={this.state.paymentInfo.raceDateZh + "<br/>" + this.state.paymentInfo.raceDateEn} />
									</td>
								</tr>


								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.raceTimeZh + ":<br/>" + this.state.fMsg.raceTimeEn + ":"} />
									</td>
									<td>
										<HTMLText text={this.state.paymentInfo.raceTimeZh + "<br/>" + this.state.paymentInfo.raceTimeEn} />
									</td>
								</tr>

								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.locationZh + ":<br/>" + this.state.fMsg.locationEn + ":"} />
									</td>
									<td>
										<HTMLText text={this.state.paymentInfo.locationZh + "<br/>" + this.state.paymentInfo.locationEn} />
									</td>
								</tr>
								<tr >
									<td className="personal-info-title-Payment" colSpan='2'>
										<HTMLText text={this.state.fMsg.personalInfoTitleZh + "&nbsp;&nbsp;&nbsp;&nbsp;" + this.state.fMsg.personalInfoTitleEn} />
									</td>
								</tr>
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.chiNameZh + ":<br/>" + this.state.fMsg.chiNameEn + ":"} />
									</td>
									<td>
										{this.state.paymentInfo.chiName}
									</td>
								</tr>
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.engNameZh + ":<br/>" + this.state.fMsg.engNameEn + ":"} />
									</td>
									<td>
										{this.state.paymentInfo.engName}
									</td>
								</tr>
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.dobZh + ":<br/>" + this.state.fMsg.dobEn + ":"} />
									</td>
									<td >
										{this.state.paymentInfo.dob}
									</td>
								</tr>
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.idZh + ":<br/>" + this.state.fMsg.idEn + ":</span>"} />
									</td>
									<td>
										{this.state.paymentInfo.idNum}
									</td>
								</tr>

								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.genderZh + ":<br/>" + this.state.fMsg.genderEn + ":"} />
									</td>
									<td>
										{this.state.paymentInfo.gender}
									</td>
								</tr>
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.raceItemTitleZh + ":<br/>" + this.state.fMsg.raceItemTitleEn + ":"} />
									</td>
									<td>
										<div dangerouslySetInnerHTML={{ __html: this.state.paymentInfo.appliedRaceDisplay }}></div>
									</td>
								</tr>
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.paymentFeeZh + ":<br/>" + this.state.fMsg.paymentFeeEn + ":"} />
									</td>
									<td>
										{this.state.paymentInfo.paymentFee}
									</td>
								</tr>
								{this.state.paymentInfo.paymentFee != 'HK$0' && (
									<tr className="row">
									<td colSpan={2}>
										<PayPalButton createOrder={this.createOrder}
											onApprove={this.onApprove}
										/>
									</td>
								</tr>
								)}
								
							</tbody>
						</table>
					</div>
				)}

			</div>
		);
	}
}

export default withRouter(Payment);